import { render } from "./ListItemDropdown.vue?vue&type=template&id=0d979d1b"
import script from "./ListItemDropdown.vue?vue&type=script&lang=js"
export * from "./ListItemDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__